import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { createBrowserRouter, Link, Outlet, RouterProvider, useLocation } from "react-router-dom";
import LoginPage from "./login/LoginPage";
import PortalsPage from "./files/PortalsPage";
import PortalPage from "./files/PortalPage";
import UsersPage from "./users/UsersPage";
import UserPage from "./users/UserPage";
import { AuthProvider, useAuth } from "./auth-context";
import { ToastContainer } from "react-toastify";

import 'react-toastify/dist/ReactToastify.css';
import { ApiProvider } from "./api-context";
import FederationsPage from "./federation/FederationsPage";
import FederationPage from "./federation/FederationPage";
import ReferralsPage from "./referrals/ReferralsPage";
import ReferralPage from "./referrals/ReferralPage";
import DevicesPage from "./devices/DevicesPage";
import UserDevicesPage from "./users/UserDevicesPage";
import EmailTemplatesPage from "./emails/EmailTemplatesPage";
import EmailTemplatePage from "./emails/EmailTemplatePage";

const Layout = () => {
    const { pathname } = useLocation();
    const { setToken } = useAuth();

    return (
        <ApiProvider>
            {
                pathname.includes('login') ? null : (
                    <div style={{
                        backgroundColor: '#c12e2a',
                        display: 'flex',
                        padding: '20px 24px',
                        gap: '24px'
                    }}>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/">HCV-SC</Link>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/users">Users</Link>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/devices">Devices</Link>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/referrals">Referrals</Link>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/portals">Portals</Link>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/federations">Organisations</Link>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px'
                        }} to="/templates">Email templates</Link>
                        <Link style={{
                            color: 'white',
                            lineHeight: '16px',
                            fontSize: '15px',
                            marginLeft: 'auto'
                        }} onClick={() => {
                            setToken('');
                        }} to="/login">Logout</Link>
                    </div>
                )
            }
            <Outlet />
        </ApiProvider>
    );
};

const router = createBrowserRouter([{
    element: <Layout/>,
    children: [
        {
            path: "/",
            element: <UsersPage/>,
        },
        {
            path: "/referrals",
            element: <ReferralsPage/>,
        },
        {
            path: "/referrer/:id",
            element: <ReferralPage/>,
        },
        {
            path: "/portals",
            element: <PortalsPage/>,
        },
        {
            path: "/portal/:id",
            element: <PortalPage/>,
        },
        {
            path: "/federations",
            element: <FederationsPage/>,
        },
        {
            path: "/federation/:id",
            element: <FederationPage/>,
        },
        {
            path: "/users",
            element: <UsersPage/>,
        },
        {
            path: "/user/:id",
            element: <UserPage/>,
        },
        {
            path: "/user/:id/devices",
            element: <UserDevicesPage/>,
        },
        {
            path: "/devices",
            element: <DevicesPage/>,
        },
        {
            path: "/templates",
            element: <EmailTemplatesPage/>,
        },
        {
            path: "/template/:id",
            element: <EmailTemplatePage/>,
        },
        {
            path: "login",
            element: <LoginPage/>,
        },
    ]
}]);

ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
).render(
    <AuthProvider>
        <RouterProvider router={router} />
        <ToastContainer
            position="bottom-left"
            autoClose={7000}
            theme="colored"
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
        />
    </AuthProvider>
);
